import React, { useEffect } from "react";
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner
  }, []); // Empty dependency array ensures it runs only once on mount

  return (
    <div className="contact-page">
      <div className="container">
        <h1>Contact & Resources</h1>
        
        {/* Logo Watermark */}
        <div className="logo-watermark">
          <img src="/logo.png" alt="Zenith World Wide Logo" className="watermark-logo" />
        </div>
        
        <section className="contact-hero">
          <h2>Get in Touch</h2>
          <p>We'd love to hear from you. Whether you have questions about our services, need support, or want to explore partnership opportunities, we're here to help.</p>
        </section>

        <div className="contact-content">
          

          <section className="contact-info-section">
            <h2>Contact Information</h2>
            <div className="contact-info">
              <div className="contact-item">
                <h3>Headquarters</h3>
                <h4>
                <p>Al Khobar 31952<br />
                Kingdom Of Saudi Arabia<br />
                </p>
                </h4>
              </div>
              <div className="contact-item">
                <h3>Phone</h3>
                <h4>
                <p>Main:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; +966 56335 2717<br />
                Sales:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; +966 56335 2717<br />
                Support: &nbsp; +966 56335 2717</p>
                </h4>
              </div>
              <div className="contact-item">
                <h3>Email</h3>
                <h4>
                <p>General: &nbsp;&nbsp; info@zenithworldwide.com<br />
                Sales: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; sales@zenithworldwide.com</p>
                </h4>
              </div>
              {/*<div className="contact-item">
                <h3>Business Hours</h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM EST<br />
                Saturday: 10:00 AM - 2:00 PM EST<br />
                Sunday: Closed</p>
              </div>*/}
            </div>
          </section>
        </div>

{/*
        <section className="resources-section">
          <h2>Resources</h2>
          <div className="resources-grid">
            <div className="resource-category">
              <h3>Documentation</h3>
              <ul>
                <li><a href="#" className="resource-link">User Guides</a></li>
                <li><a href="#" className="resource-link">API Documentation</a></li>
                <li><a href="#" className="resource-link">Technical Specifications</a></li>
                <li><a href="#" className="resource-link">Integration Guides</a></li>
              </ul>
            </div>
            <div className="resource-category">
              <h3>Support</h3>
              <ul>
                <li><a href="#" className="resource-link">Knowledge Base</a></li>
                <li><a href="#" className="resource-link">FAQ</a></li>
                <li><a href="#" className="resource-link">Video Tutorials</a></li>
                <li><a href="#" className="resource-link">Community Forum</a></li>
              </ul>
            </div>
            <div className="resource-category">
              <h3>Downloads</h3>
              <ul>
                <li><a href="#" className="resource-link">Software Downloads</a></li>
                <li><a href="#" className="resource-link">Mobile Apps</a></li>
                <li><a href="#" className="resource-link">Browser Extensions</a></li>
                <li><a href="#" className="resource-link">Desktop Applications</a></li>
              </ul>
            </div>
            <div className="resource-category">
              <h3>Legal</h3>
              <ul>
                <li><a href="#" className="resource-link">Privacy Policy</a></li>
                <li><a href="#" className="resource-link">Terms of Service</a></li>
                <li><a href="#" className="resource-link">Cookie Policy</a></li>
                <li><a href="#" className="resource-link">GDPR Compliance</a></li>
              </ul>
            </div>
          </div>
        </section>

        <section className="office-locations">
          <h2>Our Offices</h2>
          <div className="locations-grid">
            <div className="location">
              <h3>India (Headquarters)</h3>
              <p><br />
             <br />
              Phone: </p>
            </div>
            <div className="location">
              <h3>Saudi Arabia</h3>
              <p><br />
              <br />
              Phone: </p>
            </div>
           
          </div>
        </section>
        */}
      </div>
    </div>
  );
};

export default Contact;
